<script lang="ts">
  import {metadata, preview} from '@/store';
  import {onMount} from 'svelte';
  import {text} from 'svelte/internal';
  import {getInstance} from '../../../../services/animation';
  import {animationPlayerInstance} from '../../../animations/AnimationController.svelte';
  function setAnim(anim: any) {
    preview.set({textAnimation: anim.value});
    console.log('Setting the animation to:', anim);
    const animationService = getInstance();
    animationPlayerInstance.stop();
    animationService.rebuildTranscriptionAnimationData(anim.value);
    animationService.buildAnimations();
  }

  onMount(() => {
    // console.log('TEXT ANIMATION:', $preview.textAnimation)
  });
</script>

<h2 class="mb-2 text-xl font-bold">Select an animation</h2>
{#if $metadata.textAnimations}
  <div class="flex flex-col gap-2">
    {#each $metadata.textAnimations as textAnim}
      <div
        class="flex cursor-pointer items-center rounded-lg border border-gray-200 bg-white p-2 hover:bg-gray-100"
        on:keypress={() => setAnim(textAnim)}
        on:click={() => setAnim(textAnim)}
      >
        {textAnim.label}
        {#if textAnim.label === $preview.textAnimation}
          <i class="fa-solid fa-circle-check ml-auto block text-primary"></i>
        {/if}
      </div>
    {/each}
  </div>
{/if}
